import {Component, OnInit} from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {FormContainerComponent} from '../form-container/form-container.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'tw-form-checkout',
    templateUrl: './form-checkout.component.html',
    styleUrls: ['./form-checkout.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatCheckbox]
})
export class FormCheckoutComponent  extends FormContainerComponent implements OnInit {

    constructor( public fb: UntypedFormBuilder) {
        super(fb);
    }

    ngOnInit() {
    }

}


